/* eslint-disable filenames/match-exported */
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { prepareServerSideTable } from "components/templates/table-factory";
import {
  GetStudentsForMatchMoodleModulStudentsQuery,
  ResultType,
} from "graphqlBase/Students/__generated__/getStudentsForMatchMoodleModulStudents";
import { useAddMatchMoodleModulStudentsMutation } from "graphqlBase/MatchMoodleModulStudent/__generated__/addMatchMoodleModulStudents";
import { SortEnumType, StudentFilterInput, StudentSortInput } from "graphqlBase/types";
import React, { useCallback, useState } from "react";
import Modal from "components/lbc-toolkit/molecules/Modal";
import AddStundentsToPruefung from "./AddStundentsToPruefungTable";
import translations from "translations";
import Typography from "@material-ui/core/Typography";
import { useGetMapping } from "components/PagesCampusManagement/lehre/Pruefungen/PruefungUpdate";
import { useRecoilValue } from "recoil";
import { isChangedState } from "./InputCells";

type Student = ResultType<GetStudentsForMatchMoodleModulStudentsQuery["students"]>;

const { useCreateServerSideColumns, useMakeServerSideTable, makeSeverSideFilter } = prepareServerSideTable<
  Student,
  StudentFilterInput,
  StudentSortInput,
  SortEnumType
>();

interface AddStudentsToMoodleModuleProps {
  pruefungId: number;
  addStundents: (studentIds: number[]) => Promise<void>;
  studentsInPruefung: number[];
}

const useStyles = makeStyles<Theme>(
  (theme) =>
    createStyles({
      root: {
        alignItems: "flex-end",
        display: "flex",
        flexDirection: "column",
      },
      studentAddButton: {
        cursor: "pointer",
        height: "40px",
        alignItems: "center",
        appearance: "none",
        backgroundColor: theme.colors.christineRed,
        borderStyle: "none",
        // borderRadius: "4px",
        color: theme.colors.tWhite,
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        // width: "217px",
        marginBottom: "10px",
      },
      title: {
        textTransform: "uppercase",
        boxSizing: "content-box",
        fontFamily: "Roboto",
        fontStyle: "normal",
        fontWeight: 500,
        fontSize: 15,
        lineHeight: "26px",
        overflow: "hidden",
        whiteSpace: "nowrap",
        letterSpacing: "0.46px",
      },
    }),
  { name: "AddStudentsToMoodleModule" }
);

const AddStudentsToMoodleModule: React.FC<AddStudentsToMoodleModuleProps> = ({
  studentsInPruefung,
  pruefungId,
  addStundents,
}) => {
  const classes = useStyles({});

  const [edit, setEdit] = useState(false);
  const [studentIdsToAdd, setStudentIdsToAdd] = useState<number[]>([]);
  const [saveNewStudents] = useAddMatchMoodleModulStudentsMutation();
  const isChanged = useRecoilValue(isChangedState);

  const [openMdal, setOpenModal] = useState(false);
  const reset = () => {
    setEdit(false);
  };
  const persistMatchStudiengangModul = useGetMapping();

  const addStudentToMoodleModul = () => {
    if (!studentIdsToAdd.length) {
      reset();
      return;
    }
    const matchMoodleModulStudents = studentIdsToAdd.map((studentId) => studentId);

    persistMatchStudiengangModul().finally(() => {
      addStundents(matchMoodleModulStudents).then(() => {
        setEdit(false);
        setOpenModal(false);
      });
    });
  };

  const Table = useCallback(
    () =>
      edit ? (
        <AddStundentsToPruefung
          pruefungId={pruefungId}
          studentsInPruefung={studentsInPruefung}
          setStudentIdsToAdd={setStudentIdsToAdd}
        />
      ) : (
        <div />
      ),
    [setStudentIdsToAdd, pruefungId, studentsInPruefung, edit]
  );

  return (
    <>
      <Modal
        open={!!edit}
        onClose={reset}
        onCancel={reset}
        width={"80vh"}
        height={"80vh"}
        primaryCancel
        onConfirm={() => setOpenModal(true)}
        confirmLabel={"Auswahl hinzufügen"}
        title={"Studenten zu Prüfung hinzufügen"}
      >
        {edit ? Table() : <div />}
      </Modal>
      <div className={classes.root}>
        <button className={classes.studentAddButton} onClick={() => setEdit(true)}>
          <span className={classes.title}>Studenten zu Prüfung hinzufügen</span>
        </button>
      </div>
      <Modal
        open={openMdal}
        onClose={() => setOpenModal(false)}
        onCancel={() => setOpenModal(false)}
        onConfirm={addStudentToMoodleModul}
        title="Studenten zu Prüfung hinzufügen"
        confirmLabel={isChanged ? translations.globals.button.saveAndContinue : "Studenten zu Prüfung hinzufügen"}
        primaryCancel
      >
        <>
          {!isChanged ? (
            <>
              <Typography variant="h4">{translations.globals.popupMessages.AddStudentMessage}</Typography>
            </>
          ) : (
            <>
              <Typography variant="h4">{translations.globals.popupMessages.AddStudentMessage}</Typography>
              <Typography variant="h4">{translations.globals.popupMessages.examnModalMessage}</Typography>
            </>
          )}
        </>
      </Modal>
    </>
  );
};
export default AddStudentsToMoodleModule;
